import type { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { cn } from './cn.js';

/** Tableau dense : défile horizontalement dans son conteneur, chiffres alignés. */
export function Table({
  className,
  minWidth = 640,
  ...rest
}: HTMLAttributes<HTMLTableElement> & { minWidth?: number }) {
  return (
    <div className="-mx-1 overflow-x-auto px-1">
      <table
        style={{ minWidth }}
        className={cn('w-full border-collapse text-[13.5px]', className)}
        {...rest}
      />
    </div>
  );
}

export function Th({
  className,
  align,
  ...rest
}: ThHTMLAttributes<HTMLTableCellElement> & { align?: 'right' | 'left' }) {
  return (
    <th
      className={cn(
        'whitespace-nowrap border-b border-line px-3 pb-2 pt-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-ink-3',
        align === 'right' ? 'text-right' : 'text-left',
        className,
      )}
      {...rest}
    />
  );
}

export function Td({
  className,
  align,
  ...rest
}: TdHTMLAttributes<HTMLTableCellElement> & { align?: 'right' | 'left' }) {
  return (
    <td
      className={cn(
        'border-b border-line-soft px-3 py-2.5 align-middle text-ink',
        align === 'right' && 'tnum text-right',
        className,
      )}
      {...rest}
    />
  );
}
